import {
  GET_ALLOCATION_REPORT_REQUEST,
  GET_ALLOCATION_REPORT_SUCCESS,
  GET_ALLOCATION_REPORT_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

export const GetallocationReport = (token) => (dispatch) => {
  dispatch({ type: GET_ALLOCATION_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/AllocationReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_ALLOCATION_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ALLOCATION_REPORT_ERROR,
        payload: [],
      });
    });
};
